import { CSSProperties } from "react";
import { constants, spacing, theme } from "../../../layout";

export const styles: Record<string, CSSProperties> = {
  container: {
    backgroundColor: theme.input.background,
    padding: spacing.s,
    borderRadius: constants.radius.view,
  },
  left: {
    flex: 1,
  },
  right: {
    marginRight: spacing.xs,
  },
  date: {
    opacity: 0,
    position: "absolute",
  },
  disabled: {
    opacity: 0.5,
  },
};
